<wo-conditional-link
  [hasAccess]="true | ifHasPermission:'can manage suppliers'"
  [link]="id ? AppRoutingLinks.supplier(id) : undefined"
  [inMobile]="false"
>
  <ng-content/>
</wo-conditional-link>
